module.exports = __webpack_public_path__ + "static/img/4023_phase_function_Paper_PointsHejduk_Prediction.301f507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4023_phase_function_Paper_PointsHejduk_Prediction.png
// module id = A2FF
// module chunks = 0